<main class="main users chart-page card card-body" id="skip-target">
    <div class="container-fluid cardone">
      <p-toast position="center" key="c" [baseZIndex]="5000">
  
      </p-toast>
      <!-- <p class="stat-cards-info__title title">Excursion</p> -->
      <div class="row">
        <h2 class="col-6 main-title">{{Title}}</h2>
      </div>
      
      <form #formRow [formGroup]="arrdepForm" (ngSubmit)="Arrival_Departure_Report_Search(false)">
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name">Type</label>
                </div>
                <div class="col-12">
                    <ng-select [searchable]="false" formControlName="Type" (change)="typeChange($event)">
                        <ng-option *ngFor="let pr of TypeList" [value]="pr.id">{{pr.value}}</ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name">{{DateLabel}}</label>
                </div>
                <div class="col-12">
                    <p-calendar #theCalendar [readonlyInput]="true" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                    dateFormat="dd-m-yy" formControlName="dateofArrDep"></p-calendar>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name">Country Group</label>
                </div>
                <div class="col-12">
                  <p-autoComplete formControlName="CountryGroup" [suggestions]="filteredCountryGroup" 
                    (completeMethod)="filterCountryGroup($event)" field="countrygroupname" [minLength]="1">
                  </p-autoComplete>
                </div>
            </div>
            <div *ngIf="this.selectedType == 0" class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name">Country</label>
                </div>
                <div class="col-12">
                  <p-autoComplete formControlName="Country" [suggestions]="filteredCountry" 
                    (completeMethod)="filterCountry($event)" field="ctryname" [minLength]="1">
                  </p-autoComplete>
                </div>
            </div>
            <div *ngIf="this.selectedType == 1" class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name">Airport</label>
                </div>
                <div class="col-12">
                  <p-autoComplete formControlName="Airport" [suggestions]="filteredAirport" 
                    (completeMethod)="filterAirport($event)" field="airportbordername" [minLength]="1">
                  </p-autoComplete>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name">Agent</label>
                </div>
                <div class="col-12">
                  <p-autoComplete formControlName="Agent" [suggestions]="filteredAgent" 
                    (completeMethod)="filterAgent($event)" field="agentname" [minLength]="1">
                  </p-autoComplete>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name">Hotel</label>
                </div>
                <div class="col-12">
                  <p-autoComplete formControlName="Hotel" [suggestions]="filteredHotel" 
                    (completeMethod)="filterHotel($event)" field="partyname" [minLength]="1">
                  </p-autoComplete>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name">Hotel City</label>
                </div>
                <div class="col-12">
                  <p-autoComplete formControlName="HotelCity" [suggestions]="filteredHotelCity" 
                    (completeMethod)="filterHotelCity($event)" field="cityname" [minLength]="1">
                  </p-autoComplete>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name">Flight</label>
                </div>
                <div class="col-12">
                  <p-autoComplete formControlName="Flight" [suggestions]="filteredFlight" 
                    (completeMethod)="filterFlight($event)" field="flightcode" [minLength]="1">
                  </p-autoComplete>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name">Grouping</label>
                </div>
                <div class="col-12">
                    <ng-select [searchable]="false" formControlName="GroupBy">
                        <ng-option *ngFor="let pr of GroupByList" [value]="pr.id">{{pr.value}}</ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
              <div class="col-12">
                  <label class="form-label" for="name">Division</label>
              </div>
              <div class="col-12">
                <p-autoComplete formControlName="Division" [suggestions]="filteredDivision" 
                  (completeMethod)="filterDivision($event)" field="division_master_des" [minLength]="1">
                </p-autoComplete>
              </div>
          </div>
            <div class="col-lg-2 col-md-2 col-sm-6 col-xs-12 ">
                <div class="col-12">
                    <label class="form-label" for="name">&nbsp;</label>
                </div>
                <div class="col-12">
                    <input type="checkbox" formControlName="OnlyFlight" class="form-check-input"><span>Only Flight</span><br>
                    <input type="checkbox" formControlName="OnlyShifting" [hidden]="this.selectedType == 0" class="form-check-input"><span [hidden]="this.selectedType == 0">Only Shifting</span>
                </div>
            </div>
            <div class="col-lg-2 col-md-1 col-sm-6 col-xs-12 ">
                <div class="col-12 ">
                  <label class="form-label" for="name"><br></label>
                </div>
                <div class="col-12 ">
                  <button type="submit" class="primary-default-btn">Load Report</button>
                </div>
            </div>
        </div>
        <div class="row">
            <br>
        </div>
      </form>
      <div class="row cardone">
        <div style="width: 100%;" class="card table-responsive">
            <p-table responsiveLayout="stack" (onPage)="onArrDepPageChange($event)" [value]="ArrivalDepartureList"
              styleClass="p-datatable-gridlines" [loading]="loading" [paginator]="true" [rows]="10"
              [(first)]="arrdepPageIndex" [showCurrentPageReport]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [rowsPerPageOptions]="[10,20,50]">
              <ng-template pTemplate="caption">
                <div class="flex">
                    <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="arrivalDepartureExcelExport()" class="p-button-success mr-2" pTooltip="XLSX" tooltipPosition="bottom"></button>
                </div>
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr >
                    <th>Flight</th>
                    <th>Time</th>
                    <th>Pick-up From</th>
                    <th *ngIf="this.selectedType == 1">Pick-up Time</th>
                    <th>Drop-off To</th>
                    <th>Guests</th>
                    <th>No. of Guest</th>
                    <th>Reference</th>
                    <th>Voucher</th>
                    <th>Client</th>
                    <th>Country</th>
                    <th>Service Name</th>
                    <th>GSA / Supplier</th>
                    <th>Airport Rep</th>
                    <th>Remarks</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product let-columns="columns">
                <tr>
                  <td><span class="p-column-title">Flight</span>{{product.Flight}}</td>
                  <td><span class="p-column-title">Time</span>{{product.Time}}</td>
                  <td><span class="p-column-title">Pick-up From</span>{{product.PickupFrom}}</td>
                  <td *ngIf="this.selectedType == 1"><span class="p-column-title">Pick-up From</span>{{product.PickupTime}}</td>
                  <td><span class="p-column-title">Drop-off To</span>{{product.DropoffTo}}</td>
                  <td><span class="p-column-title">Guests</span>{{product.Guests}}</td>
                  <td><span class="p-column-title">No. of Guest</span>{{product.NoofGuest}}</td>
                  <td><span class="p-column-title">Reference</span>{{product.Reference}}</td>
                  <td><span class="p-column-title">Voucher</span>{{product.Voucher}}</td>
                  <td><span class="p-column-title">Client</span>{{product.Client}}</td>
                  <td><span class="p-column-title">Country</span>{{product.Country}}</td>
                  <td><span class="p-column-title">Service Name</span>{{product.ServiceName}}</td>
                  <td><span class="p-column-title">GSA / Supplier</span>{{product.Supplier}}</td>
                  <td><span class="p-column-title">Airport Rep</span>{{product.AirportRep}}</td>
                  <td><span class="p-column-title">Remarks</span>{{product.Remarks}}</td>
                </tr>
              </ng-template>
            </p-table>
        </div>
      </div>
    </div>
</main>